import { render } from "./BaseSidebarViewerPanelValue.vue?vue&type=template&id=58dbe5c1"
import script from "./BaseSidebarViewerPanelValue.vue?vue&type=script&lang=js"
export * from "./BaseSidebarViewerPanelValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__